var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAustria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_483_31642)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    transform: "translate(0.266602 0.28125)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7108 16.5874C24.1971 15.2768 24.4633 13.8591 24.4633 12.3793C24.4633 10.8994 24.1971 9.48186 23.7108 8.17118L12.365 7.11914L1.01911 8.17118C0.532813 9.48186 0.266602 10.8994 0.266602 12.3793C0.266602 13.8591 0.532813 15.2768 1.01911 16.5874L12.365 17.6394L23.7108 16.5874Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3649 24.4781C17.5667 24.4781 22.0014 21.195 23.7107 16.5879H1.01904C2.7285 21.195 7.16302 24.4781 12.3649 24.4781Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3649 0.28125C7.16302 0.28125 2.7285 3.56444 1.01904 8.1715H23.7108C22.0014 3.56444 17.5667 0.28125 12.3649 0.28125Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_483_31642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    fill: "white",
    transform: "translate(0.266602 0.28125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustria);
export default __webpack_public_path__ + "static/media/Austria.9fb8daf105525685bd9126f03eb68e83.svg";
export { ForwardRef as ReactComponent };